export default "__VITE_ASSET__BT$MYR6E__"